import { Injectable, isDevMode } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { combineLatest, first, mergeMap, Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectUser } from '../store/authentication/authentication.selector';
import { User } from '../store/authentication/model/user.model';

@Injectable()
export class HttpHeaderInterceptor implements HttpInterceptor {
    constructor(private store: Store) {}

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return combineLatest([this.store.select(selectUser)]).pipe(
            first(),
            mergeMap(([user]) => {
                const authReq = request.clone({
                    setHeaders: this.buildHeaders(user)
                });

                return next.handle(authReq);
            })
        );
    }

    private buildHeaders(user: User | null): { [name: string]: string | string[] } {
        const tenant = isDevMode() ? 'demo' : location.host.split('.').shift()!;

        let headers;
        if (user) {
            headers = {
                Accept: 'application/json, text/javascript',
                'Content-Type': 'application/json; charset=utf-8',
                'X-SkedFlex-Client': 'web',
                'X-Tenant-Id': tenant,
                Authorization: `Bearer ${user.token}`
            };
        } else {
            headers = {
                Accept: 'application/json, text/javascript',
                'Content-Type': 'application/json; charset=utf-8',
                'X-SkedFlex-Client': 'web',
                'X-Tenant-Id': tenant
            };
        }

        return headers;
    }
}
